import type { CatalogMatchResult } from "@/lib/api/catalog";

export type CatalogEntryIntent = "idle" | "checking" | "new" | "add_copy" | "receive_issue";

export function resolveCatalogEntryIntent(
  match: Pick<CatalogMatchResult, "matchType" | "biblioId"> | null | undefined
): CatalogEntryIntent {
  if (!match) return "idle";
  if (match.matchType === "isbn" && match.biblioId) return "add_copy";
  if (match.matchType === "issn" && match.biblioId) return "receive_issue";
  return "new";
}
